import React from 'react';
import type { RegistryItem } from '../types/registry';
import { useState, useEffect } from 'react';
import { supabase } from '../lib/supabase';

interface Props {
  type: 'claim' | 'contribution';
  item: RegistryItem;
  onClose: () => void;
}

export default function SuccessMessage({ type, item, onClose }: Props) {
  const [customMessage, setCustomMessage] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadCustomMessage = async () => {
      try {
        setLoading(true);
        // Use the secure RPC function to get thank you message
        const { data: thankYouMessage, error: rpcError } = await supabase
          .rpc('get_registry_thank_you_message', {
            p_registry_id: item.registry_id
          });

        if (!rpcError && thankYouMessage) {
          setCustomMessage(thankYouMessage);
        }
      } catch (err) {
        console.error('Error loading custom thank you message:', err);
      } finally {
        setLoading(false);
      }
    };

    loadCustomMessage();
  }, [item.registry_id]);

  const defaultMessage = "Thank you so much for your gift. It truly touched my heart and means more to me than words can say.";
  const messageToShow = customMessage || defaultMessage;

  return (
    <div className="fixed inset-0 bg-black/75 flex items-center justify-center p-4 z-50">
      <div className="bg-gray-800/95 backdrop-blur-sm rounded-lg p-6 max-w-md w-full">
        <h3 className="text-lg font-semibold text-white mb-4">Thank You!</h3>
        {loading ? (
          <div className="flex justify-center py-4">
            <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-white"></div>
          </div>
        ) : (
          <p className="text-gray-300 mb-6">
            {messageToShow}
          </p>
        )}
        <div className="flex flex-col space-y-4">
          {type === 'claim' && item.url && (
            <a
              href={item.url}
              target="_blank"
              rel="noopener noreferrer"
              className="w-full px-4 py-2 bg-primary text-white rounded-md hover:bg-primary-600 text-center"
            >
              View Product
            </a>
          )}
          <button
            onClick={onClose}
            className="w-full px-4 py-2 bg-gray-700 text-white rounded-md hover:bg-gray-600"
          >
            Return to Registry
          </button>
        </div>
      </div>
    </div>
  );
}